import React from 'react';
import { Button } from './Button';
export function PersuasiveCTA() {
  return <section className="py-4 px-3 bg-brand-dark flex justify-center" data-id="element-180">
      <div className="w-full max-w-lg mx-auto text-center" data-id="element-181">
        <Button className="text-sm md:text-xl py-3 md:py-4" data-id="element-182">
          🚀 SÍ, QUIERO DEJAR DE IMPROVISAR
        </Button>
      </div>
    </section>;
}